import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BetonOrderCalcParams,
  BetonOrderCalcResponse,
  BetonOrderCalcResult,
  BetonOrderFormInitialData,
  BetonOrderParams,
  BetonTypesResponse,
  OCC_ENDPOINTS,
} from '@beton/const';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BetonOrderApiService {
  constructor(
    private occEndpointsService: OccEndpointsService,
    private http: HttpClient,
  ) {}

  loadInitialData(): Observable<BetonOrderFormInitialData> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.betonTypes, {}, { prefix: false, baseSite: false });

    return this.http
      .get<BetonTypesResponse>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.betonTypes),
      })
      .pipe(
        map((res) => {
          return {
            types: res.data.items,
          };
        }),
      );
  }

  calculateOrder(data: BetonOrderCalcParams): Observable<BetonOrderCalcResult> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.betonOrderCalc, {}, { prefix: false, baseSite: false });

    return this.http
      .post<BetonOrderCalcResponse>(
        url,
        { data },
        {
          context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.betonOrderCalc),
        },
      )
      .pipe(map((res) => res.data.calcResult));
  }

  confirmOrder(data: BetonOrderParams): Observable<void> {
    const url = this.occEndpointsService.buildUrl(
      OCC_ENDPOINTS.betonOrderConfirm,
      {},
      { prefix: false, baseSite: false },
    );

    return this.http.post<void>(
      url,
      { data },
      {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.betonOrderConfirm),
      },
    );
  }
}
